import ReactOnRails from 'react-on-rails/client';
import BuildYourRoof from '../../components/ror_components/BuildYourRoof.jsx';

ReactOnRails.register({BuildYourRoof});